import { type RouteConfig } from 'vue-router'

export const ResetAppRouter: RouteConfig[] = [
  {
    path: '/reset',
    component: async () => import('./ResetApp.vue'),
  },
]
